import { Pipe, PipeTransform } from '@angular/core';
import { Routes } from '../../models/kpi-details';
import { RouteState } from '../../entity/enums';

@Pipe({
    name: 'kpiProgress',
    standalone: false
})
export class KpiProgressPipe implements PipeTransform {

  transform(kpiData: Routes, type: 'stops' | 'tasks' | 'items'): number {
    const state = kpiData.route_state.toLowerCase();
    const kpi:any = kpiData.kpi[type];
    let completed = 0;
  
    if (state === RouteState.Onroute || state === RouteState.Completed) {
      completed = type === 'items' ? 
      kpiData.kpi.items.delivered + kpiData.kpi.items.failedattempt + kpiData.kpi.items.pickup_completed
      : kpi?.completed??0;
    } else if (state === RouteState.Loading || state === RouteState.Finishloading) {
      completed = kpi.loaded??0;
    }
    return completed??0;
  }
}
